<p>Verification code: {{ token }}</p>
